import { registerComponent } from '@gig/magic-common';
import StaticPagesNavigationComponent from './static-pages-navigation.vue.js';

var StaticPagesNavigation = registerComponent(StaticPagesNavigationComponent);

export { StaticPagesNavigation };
